import stamp_anime from 'url:../assets/stamps/stamp-anime.gif';
import stamp_weblair from 'url:../assets/stamps/stamp-weblair.gif';
import stamp_phrank from 'url:../assets/stamps/stamp-phrank.gif';
import stamp_wtrok from 'url:../assets/stamps/stamp-wtrok.png';
import stamp_cryptid from 'url:../assets/stamps/stamp-cnn.png';
import stamp_tacobongo from 'url:../assets/stamps/stamp-tacobongo.gif';
import stamp_trok from 'url:../assets/stamps/stamp-trok.png';
import stamp_anime_off from 'url:../assets/stamps/stamp-anime-off.png';
import stamp_weblair_off from 'url:../assets/stamps/stamp-wlair-off.png';
import stamp_phrank_off from 'url:../assets/stamps/stamp-phranks-off.png';
import stamp_wtrok_off from 'url:../assets/stamps/stamp-wtrok-off.png';
import stamp_cryptid_off from 'url:../assets/stamps/stamp-cnn-off.png';
import stamp_tacobongo_off from 'url:../assets/stamps/stamp-taco-off.png';
import stamp_trok_off from 'url:../assets/stamps/stamp-trok-off.png';
import '../styles/basic.css';
import { useNavigate } from 'react-router';
import { Plzma } from './cursor/plz/Plzma';

export enum StampType
{
    TROK,
    Anime,
    Weblair,
    Phranks,
    TacoBongo,
    WTROK,
    Cryptid
}

export function Stamp (props: {type : StampType}) {
    const navigate = useNavigate();

    let stamp_on : string|undefined = '';
    let stamp_off : string|undefined = '';
    let link : string|undefined = undefined;
    let anim : boolean = false;
    switch (props.type)
    {
        case StampType.TROK:
            stamp_on = stamp_trok;
            stamp_off = stamp_trok_off;
            link ="/tripleoaks";
            break;
        case StampType.Anime:
            stamp_on = stamp_anime;
            stamp_off = stamp_anime_off;
            link = '/xtremeanime';
            anim = true;
            break;
        case StampType.Weblair:
            stamp_on = stamp_weblair;
            stamp_off = stamp_weblair_off;
            break;
        case StampType.Phranks:
            stamp_on = stamp_phrank;
            stamp_off = stamp_phrank_off;
            link = '/phrankscranks';
            anim = true;
            break;
        case StampType.TacoBongo:
            stamp_on = stamp_tacobongo;
            stamp_off = stamp_tacobongo_off;
            link = '/tacobongo';
            anim = true;
            break;
        case StampType.WTROK:
            stamp_on = stamp_wtrok;
            stamp_off = stamp_wtrok_off;
            link = '/wtrok';
            break;
        case StampType.Cryptid:
            stamp_on = stamp_cryptid;
            stamp_off = stamp_cryptid_off;
            link = '/cnn';
    }

    const has_link = link !== undefined;
    const secondaryClass = has_link ? 'stamp-valid' : 'stamp-invalid';

    const on_anim = <img src={stamp_on} className={'stamp ' + secondaryClass} />;
    const off_anim = <img src={stamp_off} className={'stamp ' + secondaryClass} />;
    const on_std = <img src={stamp_on} className={'stamp ' + secondaryClass} onClick={() => {
        if (link !== undefined)
            navigate(link);
    }} />;

    return anim ? <Plzma onState={on_anim} offState={off_anim} startOn={true} stdOnClick={() => {
        if (link !== undefined)
            navigate(link);
    }} /> : (has_link ? on_std : off_anim);
}